
export interface Article {
  id: string;
  title: string;
  coverImage: string;
  summary: string;
  date: string;
  tags: string[];
  status: 'published' | 'draft';
  content: string;
}

export const mockArticles: Article[] = [
  {
    id: '1',
    title: 'AI 虛擬人 IP 建構全流程解析',
    coverImage: 'https://public.readdy.ai/ai/img_res/4cd9c736ffef6e20b3f4563bedba038b.jpg',
    summary: '從概念設計到最終成品，深入解析如何打造一個具有商業價值的 AI 虛擬人 IP，涵蓋形象設計、動作捕捉、語音合成等完整流程。',
    date: '2025-06-10',
    tags: ['AI 虛擬人', 'IP 建構', '商業應用'],
    status: 'published',
    content: '',
  },
  {
    id: '2',
    title: '商業短視頻的黃金公式：如何在 15 秒內抓住觀眾',
    coverImage: 'https://readdy.ai/api/search-image?query=cinematic%20short%20video%20production%20setup%20with%20professional%20camera%20equipment%2C%20dramatic%20studio%20lighting%20with%20golden%20and%20red%20tones%2C%20dark%20moody%20atmosphere%2C%20film%20production%20behind%20the%20scenes%2C%20high%20end%20commercial%20shoot&width=800&height=500&seq=blog-cover-02&orientation=landscape',
    summary: '解析頂尖品牌短視頻的共同規律，從開場鉤子、視覺節奏到情感共鳴，提供一套可複製的商業短視頻創作框架。',
    date: '2025-05-28',
    tags: ['短視頻', '商業創作', '品牌行銷'],
    status: 'published',
    content: '',
  },
  {
    id: '3',
    title: '動態特效設計趨勢：2025 年最值得關注的視覺風格',
    coverImage: 'https://readdy.ai/api/search-image?query=stunning%20motion%20graphics%20visual%20effects%20abstract%20digital%20art%20with%20flowing%20golden%20particles%20and%20light%20trails%20on%20deep%20black%20background%2C%20futuristic%203D%20render%2C%20cinematic%20composition%2C%20luxury%20aesthetic&width=800&height=500&seq=blog-cover-03&orientation=landscape',
    summary: '盤點 2025 年最前沿的動態特效設計趨勢，包含液態金屬、粒子系統、AI 生成紋理等視覺風格，並分析其在品牌傳播中的應用場景。',
    date: '2025-05-15',
    tags: ['動態特效', '設計趨勢', '視覺設計'],
    status: 'published',
    content: '',
  },
  {
    id: '4',
    title: '3D 動畫製作流程：從分鏡到渲染的完整指南',
    coverImage: 'https://readdy.ai/api/search-image?query=professional%203D%20animation%20production%20workflow%20with%20detailed%20character%20model%20wireframe%20and%20rendered%20version%20side%20by%20side%2C%20dark%20studio%20environment%20with%20amber%20and%20gold%20accent%20lighting%2C%20high%20quality%20CGI%20render&width=800&height=500&seq=blog-cover-04&orientation=landscape',
    summary: '詳細拆解 3D 動畫製作的每個環節，從前期分鏡規劃、模型建構、材質貼圖，到燈光設置與最終渲染輸出，適合想深入了解製作流程的創作者。',
    date: '2025-04-30',
    tags: ['3D 動畫', '製作流程', 'CGI'],
    status: 'published',
    content: '',
  },
  {
    id: '5',
    title: '品牌視覺資產的長期價值：為什麼投資高品質影像值得',
    coverImage: 'https://readdy.ai/api/search-image?query=luxury%20brand%20visual%20identity%20design%20with%20elegant%20gold%20typography%20and%20minimalist%20black%20background%2C%20premium%20corporate%20branding%20materials%2C%20sophisticated%20aesthetic%2C%20high%20end%20commercial%20photography%20style&width=800&height=500&seq=blog-cover-05&orientation=landscape',
    summary: '從品牌資產的角度分析高品質視覺內容的長期回報，並以實際案例說明如何透過一次性的視覺投資，持續為品牌創造價值。',
    date: '2025-04-12',
    tags: ['品牌策略', '視覺資產', '投資回報'],
    status: 'published',
    content: '',
  },
  {
    id: '6',
    title: 'AI 影視動畫的未來：技術革新如何改變創作生態',
    coverImage: 'https://readdy.ai/api/search-image?query=futuristic%20AI%20film%20production%20concept%20with%20holographic%20screens%20showing%20animation%20timelines%20and%20neural%20network%20visualizations%2C%20dark%20cinematic%20environment%20with%20golden%20amber%20lighting%2C%20technology%20meets%20creativity&width=800&height=500&seq=blog-cover-06&orientation=landscape',
    summary: '探討 AI 技術對影視動畫產業的深遠影響，從自動化製作流程到 AI 輔助創作，分析創作者如何在技術浪潮中找到自己的定位。',
    date: '2025-03-25',
    tags: ['AI 技術', '影視動畫', '產業趨勢'],
    status: 'published',
    content: '',
  },
];
